<template>
    <div class="shop-fanbox">
        <div class="highlighted-section">
            <div class="row shop-fanbox__teaser">
                <div class="col-12 col-md-6 order-2 order-md-1">
                        <p class="teaser__heading subline subline--bold">
                            {{ $t('fanbox.teaserHeadline')}}
                        </p>
                        <p class="shop-fanbox__teaser__count">{{ fanboxList.length }} {{ $t('fanbox.fanboxItems')}}</p>
                        <div class="teaser__body" v-html="$t('fanbox.teaserBodytext')" />
                </div>
                <div class="col-12 col-md-6 order-1 order-md-2">
                    <p class="shop-fanbox__badge"> {{ $t('fanbox.badge') }}</p>
                    <global-responsive-image :responsive-image="fanboxTeaserImage" />
                </div>
            </div>
            <div class="row" v-if="selectedFanboxItems.length">
                <div class="col-12">
                    <p class="typo-light">{{ $t('fanbox.selected') }}</p>
                </div>
                <template v-for="item in selectedFanboxItems">
                    <shop-tile :tile="item" class="col-12 col-md-6" :key="item.order_pid">
                        <template slot="button-add2wishlist">
                            <span class="wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty"
                                  :data-pid="item.order_pid" :data-title="item.title"
                                  :data-titlesuffix="item.titlesuffix"
                                  :data-subtitle="item.subtitle"
                                  :data-subsubtitle="item.subsubtitle">
                            </span>
                        </template>
                        <template slot="ordercount">
                            <template v-if="selectFanbox">
                                <span class="typo-light">{{ $t('fanbox.quantity') }} {{ $store.getters.cartGetCartOrderQuantityForPimId(item.pim_id) || 1 }}</span>
                            </template>
                            <div v-else class="col-12 ordercount-input" :class="[$store.getters.cartCheckErrorItem(item.pim_id) ? 'has-error': 'no-error']" v-show="$store.getters.authenticated">
                                <global-item-quantity
                                    @updateErrorItemQuantity="$store.dispatch('addCartErrorItem', $event)"
                                    @updateCartData="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: $event})"
                                    :min="1"
                                    :value="$store.getters.cartGetCartOrderQuantityForPimId(item.pim_id) || 1"
                                    :max="parseInt(maxOrderItems)"
                                    :error-messages="{errorToSmall: $t('errorItemQuantityMin'), errorToLarge: $t('errorItemQuantityMax'), errorNotANumber: $t('errorItemQuantityEmpty')}"
                                >
                                    <span slot="amount">{{$t('orderquantity')}}</span>
                                </global-item-quantity>
                                <global-button @click="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: 0})" icon="trash" theme="secondary"/>
                            </div>
                        </template>
                        <template slot="remove-button" v-if="!selectFanbox">
                            <div class="button-wrapper spacer--top" v-show="$store.getters.authenticated === false">
                                <global-button @click="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: 0})" icon="trash" theme="secondary"/>
                            </div>
                        </template>
                    </shop-tile>
                </template>
            </div>
            <div class="row fanbox__additional-fans" :class="selectFanbox ? 'shop-fanbox--selected': 'shop-fanbox--unselected'" v-if="unselectedFanboxItems.length">
                <div class="col-12">
                    <p><strong>{{ $t('fanbox.otherFanboxItemsHeading') }}</strong></p>
                </div>

                <template v-for="item in unselectedFanboxItems">
                    <shop-tile :tile="item" class="col-12 col-md-6" :key="item.order_pid" />
                </template>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="fanbox__select">
                        <hr>
                        <global-input-checkbox :label="$t('fanbox.checkbox.label')"
                                               :value="selectFanbox" @input="toggleCheckbox" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="selectedNonFanboxItems.length">
            <template v-for="(item) in selectedNonFanboxItems">
                <shop-tile :tile="item" class="col-12 col-md-6" :key="item.order_pid">
                    <template slot="button-add2wishlist">
                        <span class="wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty"
                              :data-pid="item.order_pid" :data-title="item.title"
                              :data-titlesuffix="item.titlesuffix"
                              :data-subtitle="item.subtitle"
                              :data-subsubtitle="item.subsubtitle">
                        </span>
                    </template>
                    <template slot="ordercount">
                        <div class="col-12 ordercount-input" :class="[$store.getters.cartCheckErrorItem(item.pim_id) ? 'has-error': 'no-error']" v-show="$store.getters.authenticated">
                            <global-item-quantity
                                @updateErrorItemQuantity="$store.dispatch('addCartErrorItem', $event)"
                                @updateCartData="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: $event})"
                                :min="1"
                                :value="$store.getters.cartGetCartOrderQuantityForPimId(item.pim_id)"
                                :max="parseInt(maxOrderItems)"
                                :error-messages="{errorToSmall: $t('errorItemQuantityMin'), errorToLarge: $t('errorItemQuantityMax'), errorNotANumber: $t('errorItemQuantityEmpty')}"
                            >
                                <span slot="amount">{{$t('orderquantity')}}</span>
                            </global-item-quantity>
                            <global-button @click="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: 0})" icon="trash" theme="secondary"/>
                        </div>
                    </template>
                    <template slot="remove-button">
                        <div class="button-wrapper spacer--top" v-show="$store.getters.authenticated === false">
                            <global-button @click="$store.dispatch('changeCartOrderQuantity', {pim_id: item.pim_id, quantity: 0})" icon="trash" theme="secondary"/>
                        </div>
                    </template>
                </shop-tile>
            </template>
        </div>
    </div>
</template>

<script>
import ShopTile from "../shop-tile/shop-tile"
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox";
import GlobalButton from "@global/global-elements/global-button/global-button";
import GlobalItemQuantity from "@global/global-elements/global-item-quantity/global-item-quantity"
import GlobalResponsiveImage from "@global/global-elements/global-responsive-image/global-responsive-image";
export default {
    name: "shop-fanbox",
    props: {
        items: [],
        maxOrderItems: undefined
    },
    data() {
        return {
            fanboxTeaserImage: {}
        }
    },
    computed: {
        selectFanbox() {
            return this.$store.state.cartSelectFanbox
        },
        selectedFanboxItems() {
            return this.$store.getters.cartSelectedFanboxItems;
        },
        selectedFanboxList() {
            return this.$store.getters.cartSelectedFanboxList;
        },
        unselectedFanboxItems() {
            return this.$store.getters.cartUnselectedFanboxItems;
        },
        selectedNonFanboxItems() {
            return this.$store.getters.cartSelectedNonFanboxItems;
        },
        fanboxList() {
            return this.$store.getters.cartFanboxList
        },
        fanboxItems() {
            return this.$store.state.cartFanboxItems
        },
    },
    methods: {
        toggleCheckbox(value) {
            this.$store.dispatch('setCartSelectFanbox', value);
        }
    },
    components: {GlobalResponsiveImage, GlobalInputCheckbox, ShopTile, GlobalButton, GlobalItemQuantity},
    beforeMount() {
        if (window.fanboxTeaserImage) {
            this.fanboxTeaserImage = window.fanboxTeaserImage;
        }
    }
}
</script>
